import React, { useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import DialogContent from '@material-ui/core/DialogContent';
import DeleteIcon from '@material-ui/icons/Delete';
import StadiumButton from '../../../../../customComponents/button/StadiumButton';
import DialogActions from '@material-ui/core/DialogActions';
import { IRootState } from '../../../../../../@types/redux';
import { connect } from 'react-redux';
import OutlinedStadiumButton from '../../../../../customComponents/button/OutlinedStadiumButton';
import AppFunctionsService from '../../../../../../services/appFunctionsService';
import { ITransformerLpuReading } from '../../../../../../@types/model/transformer/reading/transformerLpuReading';
import ProjectDialog from '../../../../../customComponentV2/dialog/ProjectDialog';

interface ITransformerLPUReadingDeleteDialogProps {
    reading : ITransformerLpuReading;
    onDelete : (reading : ITransformerLpuReading) => void;
}

const TransformerLPUReadingDeleteDialog = (props : ITransformerLPUReadingDeleteDialogProps) : React.ReactElement => {
    const [open, setOpen] = useState<boolean>(false);

    const onClick = (): void => {
        setOpen(true);
    };

    const onClose = (): void => {
        setOpen(false);
    };

    const onDeleteClick = async (): Promise<void> => {  
        if (props.onDelete) props.onDelete(props.reading);      
        onClose();
    };

    return (
        <div>
            <Tooltip title='Delete'>
                <div>
                    <IconButton className={'cr'} onClick={onClick}
                        aria-label='Delete'>
                        <DeleteIcon />
                    </IconButton>
                </div>
            </Tooltip>
            <ProjectDialog
                title={`REMOVE READING | ${AppFunctionsService.formatDateTimeToDateOnly(props.reading.date)} | ${props.reading.transformerRef}`}
                isOpen={open}
                onClose={onClose}
                headerColour={'red'}
                maxWidth={'md'}
                fullWidth>
                <DialogContent className='fdc flx1 ais hfill bcg0'>
                    <div className='fdc flx1 ais jcc'>
                        <p>
                            Remove Reading?
                        </p>
                        <p>
                            This will remove all associated readings too.
                        </p>
                    </div>
                </DialogContent>
                <DialogActions className='bcg0'>
                    <OutlinedStadiumButton className='mr16' variant='text' onClick={onClose}>
                        CANCEL
                    </OutlinedStadiumButton>
                    <StadiumButton variant='contained' onClick={onDeleteClick}>
                        REMOVE
                    </StadiumButton>
                </DialogActions>
            </ProjectDialog>
        </div>
    );
};

export default TransformerLPUReadingDeleteDialog;
